import React from "react";
import { Box, Flex, VStack } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconViewer, CenteredFixedWidthContainer } from "@components";
import { BottomNavigation } from "@components/Navigation";
import { HOST_CONTAINER_WIDTH } from "@constants/layoutDimensions";
import { $Routes } from "@routes";
import { useGetPassiveNewsQuery } from "@store/api/news";

const IconViewerContainer = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: passiveNews } = useGetPassiveNewsQuery();
  const newsNotifications = passiveNews?.items ?? [];
  
  // Determine active tab based on current route
  const getActiveTab = () => {
    if (location.pathname.includes('/reports')) return 'reports';
    if (location.pathname.includes('/news')) return 'news';
    return 'agenda';
  };

  const handleTabChange = (tabId) => {
    switch (tabId) {
      case "agenda":
        navigate($Routes.allAgendaPage);
        break;
      case "reports":
        navigate($Routes.reportsPage);
        break;
      case "news":
        navigate($Routes.newsPage);
        break;
      default:
        break;
    }
  };

  return (
    <CenteredFixedWidthContainer>
      <Flex
        justifyContent="flex-end"
        height="100%"
        width="100%"
        position="relative"
      >
        <Box
          height="100%"
          width="20px"
          maxW={HOST_CONTAINER_WIDTH}
          left="2"
          position="absolute"
        >
          <IconViewer />
        </Box>
        <Flex flexDirection="column" height="100%" width="350px" bg="gray.100">
          <Box height="calc(100% - 50px - 16px)">
            <Box bg="#FAFAFB" position="relative" height="100%">
              <Box p="10px" height="100%">
                <VStack spacing="24px" align="stretch" height="100%">
                  {children}
                </VStack>
              </Box>
            </Box>
          </Box>
          <BottomNavigation
            activeTab={getActiveTab()}
            onTabChange={handleTabChange}
            notifications={newsNotifications}
          />
        </Flex>
      </Flex>
    </CenteredFixedWidthContainer>
  );
};

export default IconViewerContainer;
